import {useSelector} from 'react-redux';
import {
  selectUserEmail,
  selectUserFirstName,
  selectUserId,
  selectUserLastName,
} from '~/ViewInvitation/selectors/user';
import {isPreview} from '~/ViewInvitation/utils';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

interface DonationPanelProps {
  id: string;
  partnerKey: string;
  open: boolean;
  onClose: () => void;
}

export const DonationPanel = ({id, partnerKey, open, onClose}: DonationPanelProps) => {
  const userId = useSelector(selectUserId);
  const userFirstName = useSelector(selectUserFirstName);
  const userLastName = useSelector(selectUserLastName);
  const userEmail = useSelector(selectUserEmail);

  if (!open || isPreview()) return null;

  return (
    <ResponsivePanel
      showTitle={false}
      portalMode={true}
      showCover={true}
      modalId="donation-modal"
      isOpen={open}
      onClose={onClose}
      renderMobileViewAs="bottom-sheet"
      className="donation-panel"
    >
      <div
        className="plg-donate"
        data-partner-key={partnerKey}
        data-item-id={id}
        data-x-user-id={userId}
        data-first-name={userFirstName}
        data-last-name={userLastName}
        data-email={userEmail}
        data-style-hide-social="true"
        data-template="branding-2025"
      />
    </ResponsivePanel>
  );
};
